import { Status } from '@Components/Base';

import { TableManageRequestsActions } from '../../tableActions';
import styles from '../request-list-mobile.module.css';

interface CardProps {
  requestNo: number;
  status: string;
  requestType: string;
  items: Array<{ label: string; value: string }>;
  showAction: boolean;
  onImport: () => void;
  onExport: () => void;
  onView: () => void;
  onDelete: () => void;
}

const Card = ({
  requestNo,
  status,
  requestType,
  items,
  showAction,
  onImport,
  onExport,
  onView,
  onDelete,
}: CardProps): JSX.Element | null => {
  return (
    <div className={styles.card}>
      <div className={styles.cardManageSection}>
        <div className={styles.cardType}>{requestType}</div>
        <div className={styles.cardWrap}>
          <div className={styles.cardStatus}>
            <Status text={status} />
          </div>
          {showAction ? (
            <TableManageRequestsActions
              requestNo={requestNo}
              status={status}
              onImport={onImport}
              onExport={onExport}
              onView={onView}
              onDelete={onDelete}
            />
          ) : null}
        </div>
      </div>
      <div className={styles.cardInfoSection}>
        {items?.map((item) => (
          <div key={item.label} className={styles.cardInfoType}>
            <span>{item.label}</span>
            <span className={item.value.length > 10 ? styles.textOverflow : ''}>
              {item.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Card;
